exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-05e0e708] {\r\n  color: black !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.125) !important;\r\n  border-radius: 0.25rem !important;\n}\r\n", ""]);

// exports
